class SalutStockFilter extends HTMLElement {
  static param = 'filter.v.availability';
  static allMarker = 'salut_all';

  connectedCallback() {
    this.syncMarker();
    this.onChange = (event) => {
      if (event.target.name === SalutStockFilter.param) this.syncMarker();
    };
    this.addEventListener('change', this.onChange);

    this.observer = new MutationObserver(() => this.syncMarker());
    this.observer.observe(this, {childList: true, subtree: true});

    if (this.needsPreselect()) this.preselect();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    this.observer?.disconnect();
  }

  get inputs() {
    return Array.from(this.querySelectorAll(`input[name="${SalutStockFilter.param}"]`));
  }

  needsPreselect() {
    const params = new URLSearchParams(window.location.search);
    return !params.has(SalutStockFilter.param) && !params.has(SalutStockFilter.allMarker);
  }

  syncMarker() {
    const forms = new Set(this.inputs.map((input) => input.form).filter(Boolean));

    forms.forEach((form) => {
      const marker = form.querySelector(`input[name="${SalutStockFilter.allMarker}"]`);
      const showsAll = !form.querySelector(`input[name="${SalutStockFilter.param}"]:checked`);

      if (showsAll && !marker) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = SalutStockFilter.allMarker;
        input.value = '1';
        form.appendChild(input);
      } else if (!showsAll && marker) {
        marker.remove();
      }
    });
  }

  async preselect() {
    const container = this.querySelector('#ProductGridContainer');
    if (!container) return;

    this.showSkeleton(container);

    const params = new URLSearchParams(window.location.search);
    params.set(SalutStockFilter.param, '1');
    params.set('section_id', this.dataset.sectionId);

    try {
      const response = await fetch(`${window.location.pathname}?${params}`);
      if (!response.ok) throw new Error(response.status);

      this.swap(new DOMParser().parseFromString(await response.text(), 'text/html'));
    } catch (error) {
      this.restore(container);
    }
  }

  swap(html) {
    ['#ProductGridContainer', '#main-collection-filters'].forEach((selector) => {
      const source = html.querySelector(selector);
      const target = this.querySelector(selector);
      if (source && target) target.innerHTML = source.innerHTML;
    });
  }

  showSkeleton(container) {
    const grid = container.querySelector('#product-grid');
    if (!grid) return;

    this.placeholder = grid.innerHTML;
    const card = document.getElementById('SalutStockFilterSkeleton')?.innerHTML ?? '';
    const count = grid.children.length || 6;
    grid.innerHTML = Array.from({length: count}, () => `<li class="grid__item">${card}</li>`).join('');
  }

  restore(container) {
    const grid = container.querySelector('#product-grid');
    if (grid && this.placeholder) grid.innerHTML = this.placeholder;
  }
}

if (!customElements.get('salut-stock-filter')) {
  customElements.define('salut-stock-filter', SalutStockFilter);
}
